import React, { PropsWithChildren, createContext, useContext } from 'react';

import { PermissionResponse, PermissionStatus } from 'expo-modules-core';
import { useTrackingPermissions } from 'expo-tracking-transparency';

import { useMemoAll } from 'utils/use-memo-all';

export interface IAttPermissionContext {
  isAttPermissionKnown: boolean;
  isLoadingAttPermission: boolean;
  trackingPermissionGranted: boolean;
  requestAttPermission: () => Promise<PermissionResponse>;
}

export const AttPermissionContext = createContext<IAttPermissionContext>(
  {} as IAttPermissionContext
);

export const useAttPermission = () => useContext<IAttPermissionContext>(AttPermissionContext);

export const AttPermissionProvider = ({ children }: PropsWithChildren<{}>) => {
  const [settings, requestPermission] = useTrackingPermissions();

  const isAttPermissionKnown = !!settings && settings?.status !== PermissionStatus.UNDETERMINED;
  const isLoadingAttPermission = !settings;
  const trackingPermissionGranted = !!settings && settings?.status === PermissionStatus.GRANTED;

  const value = useMemoAll({
    isAttPermissionKnown,
    isLoadingAttPermission,
    trackingPermissionGranted,
    requestAttPermission: requestPermission,
  });

  return <AttPermissionContext.Provider value={value}>{children}</AttPermissionContext.Provider>;
};
